import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import AdaptiveImage from 'rebook/apps/utils/components/AdaptiveImage';

import styles from './style.scss';


const DashboardBanner = ({ banner, square_picture: squarePicture, link }) => {
  const bannerImage = (
    <div className={styles.itemImage}>
      {squarePicture || banner
        ? (
          <AdaptiveImage
            className={styles.image}
            src={{
              url: banner || squarePicture,
              width: '1136',
              height: '340',
            }}
            srcSet={{
              url: squarePicture || banner,
              width: '1080',
              height: '1080',
            }}
            media="max-width: 500px"
            alt="" />
        )
        : <div className={styles.imageEmpty} />
      }
    </div>);

  return (
    <div className={classNames('swiper-slide-point', styles.item)}>
      <div>
        {link
          ? (
            <a href={link}>
              {bannerImage}
            </a>
          )
          : bannerImage
        }
      </div>
    </div>
  );
};

DashboardBanner.propTypes = {
  banner: PropTypes.string.isRequired,
  square_picture: PropTypes.string,
  link: PropTypes.string,
};

DashboardBanner.defaultProps = {
  square_picture: null,
};

export default DashboardBanner;
